import { useState, useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { ProtectedRoute, useAuth } from "./auth";
import { isAuthConfigured } from "./auth";
import { apiRequest } from "./auth/msalConfig";
import AppHeader from "./components/AppHeader";
import SwaggerView from "./components/SwaggerView";
import "./App.css";

function AppContent() {
  const { isAuthenticated, account } = useAuth();
  const { instance } = useMsal();
  const [accessToken, setAccessToken] = useState(null);
  const [tokenError, setTokenError] = useState(null);

  useEffect(() => {
    if (!isAuthenticated) return;
    const activeAccount =
      account || instance.getActiveAccount() || instance.getAllAccounts()[0];
    if (!activeAccount) return;
    setTokenError(null);
    instance
      .acquireTokenSilent({ ...apiRequest, account: activeAccount })
      .then((r) => {
        setAccessToken(r.accessToken);
        setTokenError(null);
      })
      .catch(() => {
        setAccessToken(null);
        setTokenError(true);
      });
  }, [isAuthenticated, account, instance]);

  return (
    <div className="mds">
      <div className="mds-container">
        {isAuthConfigured && <AppHeader />}
        <main className="app-main">
          <SwaggerView
            accessToken={accessToken}
            requireAuth
            tokenError={tokenError}
          />
        </main>
      </div>
    </div>
  );
}

function App() {
  if (!isAuthConfigured()) {
    return (
      <div className="mds">
        <div className="mds-container">
          <main className="app-main">
            <SwaggerView />
          </main>
        </div>
      </div>
    );
  }

  return (
    <ProtectedRoute>
      <AppContent />
    </ProtectedRoute>
  );
}

export default App;
